/**
 * Collection filter URL slugs: show category slugs (e.g. bracelet, wedding-bands)
 * in the URL instead of Shopify GIDs for filter.p.m.custom.jewelry_type_filter.
 * Depends on facets.js and the FacetFilterGidSlugMap JSON in facets.liquid.
 */
(function() {
  'use strict';

  function getGidSlugMap() {
    var el = document.getElementById('FacetFilterGidSlugMap');
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function searchParamsReplaceFilterValues(searchParamsStr, useSlugInUrl) {
    var map = getGidSlugMap();
    if (!map.length) return searchParamsStr;
    var str = searchParamsStr;
    map.forEach(function(entry) {
      var param = entry.param;
      var gid = entry.gid;
      var slug = entry.slug;
      var encodedGid = encodeURIComponent(gid);
      var encodedSlug = encodeURIComponent(slug);
      var escapedParam = param.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var regex = new RegExp('(' + escapedParam + ')=([^&]*)', 'g');
      str = str.replace(regex, function(match, p1, p2) {
        var decoded;
        try {
          decoded = decodeURIComponent(p2.replace(/\+/g, ' '));
        } catch (e) {
          return match;
        }
        if (useSlugInUrl) {
          return (decoded === gid || p2 === encodedGid) ? p1 + '=' + encodedSlug : match;
        } else {
          return (decoded === slug || p2 === slug || p2 === encodedSlug) ? p1 + '=' + encodedGid : match;
        }
      });
    });
    return str;
  }

  function initFilterUrlSlugs() {
    if (typeof FacetFiltersForm === 'undefined') return;

    var map = getGidSlugMap();
    if (!map.length) return;

    var originalUpdateURLHash = FacetFiltersForm.updateURLHash.bind(FacetFiltersForm);
    FacetFiltersForm.updateURLHash = function(searchParams) {
      var displayParams = searchParamsReplaceFilterValues(searchParams, true) || searchParams;
      history.pushState(
        { searchParams: displayParams },
        '',
        window.location.pathname + (displayParams ? '?'.concat(displayParams) : '')
      );
      updateActiveCollectionButtons();
    };

    var originalRenderPage = FacetFiltersForm.renderPage.bind(FacetFiltersForm);
    FacetFiltersForm.renderPage = function(searchParams, event, updateURLHash) {
      if (updateURLHash === undefined) updateURLHash = true;
      var searchParamsForFetch = searchParamsReplaceFilterValues(searchParams, false) || searchParams;
      originalRenderPage(searchParamsForFetch, event, updateURLHash);
    };

    var search = window.location.search.slice(1);
    if (search) {
      var withGid = searchParamsReplaceFilterValues(search, false);
      if (withGid !== search) {
        window.location.replace(window.location.pathname + '?' + withGid);
        return;
      }
      var withSlug = searchParamsReplaceFilterValues(search, true);
      if (withSlug !== search) {
        history.replaceState(
          { searchParams: withSlug },
          '',
          window.location.pathname + '?' + withSlug
        );
        FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
        FacetFiltersForm.searchParamsPrev = FacetFiltersForm.searchParamsInitial;
      }
    }
  }

  var JEWELRY_FILTER_PARAM = 'filter.p.m.custom.jewelry_type_filter';

  function parseSearchParamsMulti(searchStr) {
    var out = {};
    if (!searchStr || typeof searchStr !== 'string') return out;
    searchStr.split('&').forEach(function(pair) {
      var i = pair.indexOf('=');
      if (i === -1) return;
      var key = pair.slice(0, i);
      var val = pair.slice(i + 1);
      if (!out[key]) out[key] = [];
      if (out[key].indexOf(val) === -1) out[key].push(val);
    });
    return out;
  }

  function buildSearchParamsMulti(params) {
    var parts = [];
    Object.keys(params).forEach(function(key) {
      var vals = params[key];
      if (!Array.isArray(vals) || vals.length === 0) return;
      vals.forEach(function(v) {
        parts.push(key + '=' + encodeURIComponent(decodeURIComponent(v)));
      });
    });
    return parts.join('&');
  }

  function getJewelryFilterValueFromLink(linkHref) {
    try {
      var url = new URL(linkHref, window.location.origin);
      var parsed = parseSearchParamsMulti(url.search.slice(1));
      var arr = parsed[JEWELRY_FILTER_PARAM];
      return arr && arr.length ? arr[0] : null;
    } catch (e) {
      return null;
    }
  }

  function decodeParamVal(v) {
    try {
      return decodeURIComponent(String(v).replace(/\+/g, ' '));
    } catch (e) {
      return v;
    }
  }

  function mergeJewelryFilterIntoCurrent(currentSearchStr, newValue) {
    var parsed = parseSearchParamsMulti(currentSearchStr);
    var current = parsed[JEWELRY_FILTER_PARAM] || [];
    var normalizedNew = decodeParamVal(newValue);
    var decodedCurrent = current.map(decodeParamVal);
    var idx = decodedCurrent.indexOf(normalizedNew);
    if (idx !== -1) {
      current.splice(idx, 1);
    } else {
      current.push(normalizedNew);
    }
    parsed[JEWELRY_FILTER_PARAM] = current;
    return buildSearchParamsMulti(parsed);
  }

  function updateActiveCollectionButtons() {
    var search = window.location.search.slice(1);
    var parsed = parseSearchParamsMulti(search);
    var activeValues = (parsed[JEWELRY_FILTER_PARAM] || []).map(decodeParamVal).map(function(v) { return v.toLowerCase(); });
    document.querySelectorAll('.collection-filter__link').forEach(function(link) {
      var linkValue = getJewelryFilterValueFromLink(link.href);
      if (!linkValue) {
        link.classList.remove('is-active');
        return;
      }
      var normalized = decodeParamVal(linkValue).toLowerCase();
      if (activeValues.indexOf(normalized) !== -1) {
        link.classList.add('is-active');
      } else {
        link.classList.remove('is-active');
      }
    });
  }

  function initCollectionFilterNoRefresh() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('.collection-filter__link');
      if (!link || !link.href) return;
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.pathname !== window.location.pathname) return;
        var linkSearch = url.search.slice(1);
        if (!linkSearch) return;
        var newFilterValue = getJewelryFilterValueFromLink(link.href);
        if (!newFilterValue) return;
        e.preventDefault();
        if (typeof FacetFiltersForm === 'undefined') {
          window.location.href = link.href;
          return;
        }
        var currentSearch = window.location.search.slice(1);
        var mergedSearch = mergeJewelryFilterIntoCurrent(currentSearch, newFilterValue);
        var searchParamsForFetch = searchParamsReplaceFilterValues(mergedSearch, false) || mergedSearch;
        FacetFiltersForm.renderPage(searchParamsForFetch, null);
      } catch (err) {}
    });
  }

  function init() {
    initFilterUrlSlugs();
    initCollectionFilterNoRefresh();
    updateActiveCollectionButtons();
    window.addEventListener('popstate', updateActiveCollectionButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


